module.exports = __webpack_public_path__ + "img/zoomin.e984a593.svg";